var map = {
	"./Electric_Type_Icon.png": 34251,
	"./Fire_Type_Icon.png": 50198,
	"./Ghost_Type_Icon.png": 13827,
	"./Mineral_Type_Icon.png": 12044,
	"./Normal_Type_Icon.png": 35927,
	"./Plant_Type_Icon.png": 69421,
	"./Psychic_Type_Icon.png": 8883,
	"./Water_Type_Icon.png": 49283,
	"./Wind_Type_Icon.png": 94868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62555;